export default "__VITE_ASSET__DzeAPUjA__"